import React from "react";
import { Node } from "../../types";
import scrollTo from "../../util/scrollTo";

type Props = {
  node: Node;
};

/**
 * Used to create a single entry for the table of contents for the function documentation.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const TableOfContentSection = ({ node }: Props) => {
  const funcs =
    node.functions &&
    node.functions.map((f, index) => (
      <li key={`toc${node.id}-${f.label}-${index}`} className="be_chapter-item">
        <a onClick={() => scrollTo(".be_doc", `${node.name}-${f.label}`)}>
          {f.label}
        </a>
      </li>
    ));

  return (
    <>
      <li className="be_chapter-item">
        <a onClick={() => scrollTo(".be_doc", `${node.name}`)}>{node.name}</a>
      </li>
      <li className="be_chapter-item">
        <ol>{funcs}</ol>
      </li>
    </>
  );
};

export default TableOfContentSection;
